import { useEffect } from 'react';
import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import EditMeasurement from './EditMeasurement';
import { getMeasurement, selectMeasurement, writeMeasurement } from './measurementSlice';
import { MeasurementUpdate } from './types';

type RouteMeasurementDetailParams = {
  measurementID: string;
}

const RouteMeasurementEdit = () => {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  let { measurementID } = useParams<keyof RouteMeasurementDetailParams>() as RouteMeasurementDetailParams;

  const measurement = useSelector((state: RootState) => selectMeasurement(state));
  const measurementStatus = useSelector((state: RootState) => state.measurement.status)
  const measurementError = useSelector((state: RootState) => state.measurement.error)

  useEffect(() => {
    if (auth.authToken) {
      dispatch(getMeasurement({
        authToken: auth.authToken,
        measurementID: measurementID,
        includeEntries: false,
      }));
    }
  }, [dispatch, auth.authToken, measurementID]);

  const onSaveClicked = (m: MeasurementUpdate) => {
    if (auth.authToken) {
      dispatch(writeMeasurement({
        authToken: auth.authToken,
        measurement: m,
      }));
    } else {
      console.log('No auth token!');
    }
  }

  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to={`/measurement/${measurementID}`}>
            <Button variant='secondary'>View</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          {measurementStatus === 'loading' && <LoadingIndicator />}
          {measurementError && <div>{measurementError}</div>}
          {measurement && (
            <EditMeasurement measurement={measurement} onSave={onSaveClicked} />
          )}
        </Col>
      </Row>
    </>
  );
};

export default RouteMeasurementEdit;
